/* Copyright (C) Okahu Inc 2023-2024. All rights reserved.*/

import * as go from 'gojs';

import { highlightPath } from '../../../helpers/graph';
import { NODE_STYLES } from '../graph-config';
import { GoMake } from './shared';

/**
 * End node template (circle with centered stop-square icon)
 */
export function createEndNodeTemplate($: GoMake): go.Node {
  return $(
    go.Node,
    'Spot',
    {
      selectionAdorned: false,
      layoutConditions: go.LayoutConditions.Added | go.LayoutConditions.Removed,
      locationSpot: go.Spot.Center,
      mouseEnter: (_e: go.InputEvent, obj: go.GraphObject) => {
        highlightPath(obj as go.Node, null, true, true);
      },
      mouseLeave: (_e: go.InputEvent, obj: go.GraphObject) => {
        highlightPath(obj as go.Node, null, false, true);
      },
    },
    new go.Binding('location', 'location', go.Point.parse, go.Point.stringify),
    // Inner Auto panel for proper sizing
    $(
      go.Panel,
      'Auto',
      $(go.Shape, NODE_STYLES.end.shape, {
        desiredSize: NODE_STYLES.end.size,
        fill: NODE_STYLES.end.fill,
        stroke: NODE_STYLES.end.stroke,
        strokeWidth: NODE_STYLES.end.strokeWidth,
      }),
      // Stop rectangle icon centered inside the circle
      $(go.Picture, {
        desiredSize: NODE_STYLES.start.icon.size,
        imageStretch: go.ImageStretch.Uniform,
      },
      new go.Binding('source', 'source'))
    ),
    // Top port for connections from turns or agents
    $(go.Shape, 'Circle', {
      width: 2,
      height: 2,
      fill: 'transparent',
      stroke: 'transparent',
      portId: 'top',
      alignment: go.Spot.Top,
      fromLinkable: true,
      toLinkable: true,
    })
  );
}
